import React, { useEffect, useContext } from "react";
import AppContext from "../contexts/AppContext";
import { Auth } from "aws-amplify";

import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "../assets/styles/components/sidebar_project_list";
import { useBookmark } from "../hooks/useBookmark";
import CustomBox from "../components/templates/customBox";
import { SidebarProjectListItem } from "./sidebar_project_list_item";
const useStyles = makeStyles(componentStyles);

const SidebarBookmarkList = (props) => {
  const { loading, setLoading, bookmarks, readBookmarks, errors } =
    useBookmark();
  const { setAnchorEl } = props;
  const { state } = useContext(AppContext);
  const classes = useStyles();

  useEffect(() => {
    setLoading(true);
    Auth.currentUserInfo().then(async (res) => {
      if (res) {
        await readBookmarks();
      }
    });
  }, [state.current.redmineurl, state.siteConfigs]);

  return (
    <>
      <CustomBox loading={loading} errors={errors}>
        <List className={classes.listRoot}>
          <SidebarProjectListItem
            projects={bookmarks}
            setAnchorEl={setAnchorEl}
          />
        </List>
      </CustomBox>
    </>
  );
};

export default SidebarBookmarkList;
